import { IPaymentSettings } from '../Settings/paymentSettings/paymentSettings.types';

export const getSecondaryTagName = (
  primaryTagName: IPaymentSettings['titleTag'],
) => {
  switch (primaryTagName) {
    case 'h1':
      return 'h2';
    case 'h2':
      return 'h3';
    case 'h3':
      return 'h4';
    case 'h4':
      return 'h5';
    case 'h5':
      return 'h6';
    default:
      return 'p';
  }
};
